import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import {selectors as authSelector} from 'App/util/redux/auth/index';

import messages from 'App/util/common/messages';


import {Role, setupAccess} from 'App/util/common/access_control';

import {renderWhileLoading, renderForError} from 'App/util/recompose/graphql';
import {Button, Card, CardBody, CardHeader, Form, FormGroup, Input, Label} from 'reactstrap';

@compose(
  setupAccess([], [Role.readOnly, Role.admin, Role.superAdmin]),
  connect(
    (state) => ({
      user: authSelector.user(state)
    })
  ),
  graphql(
    gql`
    mutation updateUserSettings($userId: Int!, $input:User_Input!) {
      update {
        user(user_id:$userId,input:$input) {
          last_name
          first_name
        }
      }
    }
    `, {name: 'updateUserMutation'}
  ),
  graphql(
    gql`
    mutation updatePasswordMutation($userId: Int!, $input:User_Password_Input!) {
      update {
        user_password(user_id:$userId,input:$input) {
          user_id
        }
      }
    }
    `, {name: 'updatePasswordMutation'}
  ),
  graphql(
    gql`
    query userSettings($userId: Int!) {
      user(user_id: $userId) {
        user_id
        last_name
        first_name
        verified
        blocked
        name
        role
        email
      }
      users_types {
        name
        id
      }
    }
    `,
    {
      options: ({user: {user_id}}) => ({variables: {userId: user_id}, fetchPolicy: 'cache-and-network'}),
    }
  ),
  renderWhileLoading(),
  renderForError()
)
class UserSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password: 'pass',
      firstName: '',
      lastName: '',
      email: '',
      blocked: false,
      verified: false,
      initialized: false
    }
  }

  save() {

    // save rest
    this.props.updateUserMutation(
      {
        variables: {
          input: {
            last_name: this.state.lastName,
            first_name: this.state.firstName,
          },
          userId: this.props.user.user_id
        }
      }
    ).then((data) => {
        if (!data.errors) {
          let message = 'user data ';
          if (this.state.password != 'pass') {
            this.props.updatePasswordMutation(
              {
                variables: {
                  input: {
                    password: this.state.password
                  },
                  userId: this.props.user.user_id
                }
              }
            ).then((data) => {
              if (!data.errors) messages.alert('', message + 'and password changed!');
              else messages.alert('Error', 'An error occured:' + data.error.message);
            }).catch(e => messages.alert('Error', e.message));
          } else {
            messages.alert('',message + 'changed!');
          }
        } else {
          messages.alert('Error', 'An error occured:' + data.error.message);
        }
      }
    ).catch(e => messages.alert('Error', e.message));
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render() {
    const user = this.props.data.user;

    // push data which are loaded by graphql
    // into the widgets state
    if (!this.state.initialized) {
      this.state =
        {
          password: 'pass',
          firstName: user.first_name || '',
          lastName: user.last_name || '',
          email: user.email,
          blocked: user.blocked,
          verified: user.verified,
          initialized: true
        };
    }

    const userTypes = this.props.data.users_types;
    const options = userTypes.map((userType) =>
      <option default={userType.name == user.role} key={userType.id}>{userType.name}</option>
    );

    return (
      <div>
        <Card>
          <CardHeader>User profile settings</CardHeader>
          <CardBody>
            <Form>
              <FormGroup>
                <Label>username</Label>
                <Input plaintext>
                  {user.name}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Password</Label>
                <Input onChange={this.handleInputChange.bind(this)} type="password"
                       placeholder="password"
                       value={this.state.password}
                       name="password"
                       disabled={user.name == 'user'}
                />
              </FormGroup>
              <FormGroup>
                <Label>email</Label>
                <Input plaintext>
                  {this.state.email}
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>first name</Label>
                <Input onChange={this.handleInputChange.bind(this)}
                       value={this.state.firstName} type="text"
                       placeholder="first name"
                       name="firstName"/>
              </FormGroup>
              <FormGroup>
                <Label>last name</Label>
                <Input onChange={this.handleInputChange.bind(this)}
                       value={this.state.lastName} type="text"
                       placeholder="last name"
                       name="lastName"/>
              </FormGroup>
              <FormGroup>
                <Label>User type</Label>
                <Input type="select" placeholder="select" disabled="disabled">
                  {options}
                </Input>
              </FormGroup>
              <FormGroup check>
                <Label check>
                <Input type="checkbox" checked={this.state.verified}
                       onChange={this.handleInputChange.bind(this)}
                       name="verified"
                       disabled
                />{' '}verified</Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                <Input type="checkbox" checked={this.state.blocked}
                       onChange={this.handleInputChange.bind(this)}
                       name="blocked"
                       disabled
                />{' '}blocked</Label>
              </FormGroup>

              <Button onClick={() => this.save()}>save</Button>
            </Form>
          </CardBody>
        </Card>
      </div>
  );
  }
  }

  export default UserSettings;


// WEBPACK FOOTER //
// ./src/views/User/Settings/Settings.js